import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import { Button } from '@ipc/ipc-components';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { putMemberPoolStorageEditRequestActionCreator } from '../redux/actions/MemberPoolStorageEditActions';

class MemberPoolStorageEditContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      trayPoolCount: null,
      palletPoolCount: null,
      trayPoolCountDisabled: false,
      palletPoolCountDisabled: false,
    };
  }

  isFormValid = () => !(this.state.palletPoolCount === ''
    || this.state.palletPoolCount === null
    || this.state.palletPoolCount < 1
    || this.state.trayPoolCount === ''
    || this.state.trayPoolCount < 240
    || this.state.trayPoolCount === null)

  onCountChange = (e) => {
    if (e.target.id === 'newTrayStorageCount') {
      this.setState({
        palletPoolCountDisabled: true,
        palletPoolCount: Math.ceil(e.target.value / 240),
        trayPoolCount: e.target.value,
        errorMessages: e.target.value < 240 ? 'The minimum values for New Member pool storage Pallets and New Member pool storage Trays are set respectively as 1 and 240' : '',
      });
    } else {
      this.setState({
        trayPoolCountDisabled: true,
        trayPoolCount: e.target.value * 240,
        palletPoolCount: e.target.value,
        errorMessages: e.target.value < 1 ? 'The minimum values for New Member pool storage Pallets and New Member pool storage Trays are set respectively as 1 and 240' : '',
      });
    }
  };

  onEditConfirm = () => {
    this.props.putMemberPoolStorageEditRequestActionCreator(
      this.props.operatorCode,
      this.state.palletPoolCount,
      this.state.trayPoolCount,
    );

    this.props.onCancel();
  }

  render() {
    const {
      errorMessages,
    } = this.state;
    return (
      <div className="form-container">
        <table className="operator-impc-detail" style={{ width: '50%' }}>
          <tbody>
            <tr>
              <td>
                Operator Code
              </td>
              <td>
                {this.props.operatorCode}
              </td>
            </tr>
            <tr>
              <td>
                New Member pool storage Trays
              </td>
              <td>
                <TextField
                  id="newTrayStorageCount"
                  type="number"
                  value={this.state.trayPoolCount !== null ? this.state.trayPoolCount : this.props.trayStorageCount}
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    step: 1,
                    min: 240,
                  }}
                  disabled={this.state.trayPoolCountDisabled}
                  onChange={this.onCountChange}
                />
              </td>
            </tr>
            <tr>
              <td>
                New Member pool storage Pallets
              </td>
              <td>
                <TextField
                  id="newPalletStorageCount"
                  type="number"
                  value={this.state.palletPoolCount !== null ? this.state.palletPoolCount : this.props.palletStorageCount}
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    step: 1,
                    min: 1,
                  }}
                  disabled={this.state.palletPoolCountDisabled}
                  onChange={this.onCountChange}
                />
              </td>
            </tr>
            <tr>
              <td colSpan={2} style={{ color: 'red' }}>
                {errorMessages}
              </td>
            </tr>
            <tr>
              <td>
                <Button onClick={this.props.onCancel}>Cancel</Button>
              </td>
              <td>
                <Button
                  onClick={this.onEditConfirm}
                  className={`primary-button-${!this.isFormValid()}`}
                  disabled={!this.isFormValid()}
                >
                  Confirm
                </Button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

MemberPoolStorageEditContainer.propTypes = {
  operatorCode: PropTypes.string,
  trayStorageCount: PropTypes.string,
  palletStorageCount: PropTypes.string,
  onCancel: PropTypes.func,
  putMemberPoolStorageEditRequestActionCreator: PropTypes.func,
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  putMemberPoolStorageEditRequestActionCreator,
}, dispatch);

export default connect(null, mapDispatchToProps)(MemberPoolStorageEditContainer);
